import React, { useEffect, useState } from 'react'
import { Avatar, Image, Link, ModalComponent, VideoOverlay } from 'newComponents'
import CtaArrow from '../../../components/ctaArrow'
import './styles.scss'

const TwoColumns = (props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { heading, leftImage, logo, text, video, avatar, fullName, jobTitle, image, starBackground, actions } = props

  const classNames = `two-columns ${starBackground ? 'star-background' : ''} ${avatar ? 'avatar' : ''} ${
    leftImage ? 'left-image' : ''
  }`

  const toggleVideoModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <>
      <section className={classNames}>
        <div className="container u-padding-none-mobile">
          <div className="two-columns-details">
            <div className="two-columns-logo">
              <Image className="two-columns-logo-image" image={logo} />
            </div>
            <h2 className="two-columns-heading">{heading}</h2>
            <p className="two-columns-text">{text}</p>
            {avatar && (
              <Avatar
                avatar={avatar}
                fullName={fullName}
                jobTitle={jobTitle}
                lightText={starBackground}
              />
            )}
            {actions && (
              <div className="two-columns-actions">
                {actions.map((action) =>
                  video ? (
                    <a
                      onClick={toggleVideoModal}
                      tabIndex="0"
                      role="button"
                      className="cta"
                    >
                      {action.label} {action.hasCtaArrow && <CtaArrow />}
                    </a>
                  ) : (
                    <Link
                      to={action.to}
                      tabindex="0"
                      className={action.className || 'cta'}
                      key={action.label}
                    >
                      {action.label} {action.hasCtaArrow && <CtaArrow />}
                    </Link>
                  )
                )}
              </div>
            )}
          </div>
          <div className="two-columns-video-frame">
            <Image className="two-columns-video" image={image} />
            {video && <VideoOverlay toggleVideoModal={toggleVideoModal} />}
          </div>
        </div>
      </section>
      {video && (
        <ModalComponent modalOpen={modalOpen} toggleModal={toggleVideoModal}>
          <div className="modal-content-video">
            <div className="section">
              <iframe
                title="LaunchDarkly testimonial by HoneyComb"
                src={video}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </>
  )
}

export default TwoColumns
